import { Card } from '@mui/material';
import type { JSONContent } from '@tiptap/react';
import RichContent from '@/components/shared/rich-content';

export default function Explanation({
  explanationNode,
}: {
  explanationNode: JSONContent;
  isCorrect: boolean;
}) {
  if (!explanationNode) {
    return null;
  }

  return (
    <Card
      sx={{
        p: 1,
        fontSize: 12,
        userSelect: 'none',
        mb: 3,
      }}
      variant="outlined">
      <RichContent content={explanationNode} noParagraphMargin />
    </Card>
  );
}
